import * as React from 'react';

export const Analytics = () => {
  React.useEffect(() => {
    (function(d, w, c) {
      (w[c] = w[c] || []).push(function() {
        try {
          /* tslint:disable-next-line */
          w.yaCounter34378465 = new Ya.Metrika({
            id: 34378465,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
          });
        } catch (e) {}
      });

      var n = d.getElementsByTagName('script')[0],
        s = d.createElement('script'),
        f = function() {
          n.parentNode.insertBefore(s, n);
        };
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://mc.yandex.ru/metrika/watch.js';

      if (w.opera == '[object Opera]') {
        d.addEventListener('DOMContentLoaded', f, false);
      } else {
        f();
      }
    })(document, window, 'yandex_metrika_callbacks');

    (window.Image ? new Image() : document.createElement('img')).src =
      location.protocol +
      '//vk.com/rtrg?r=qpDbtDC*6FzaK4705cZj6C6847F8Dh6h*jkEH4o4gQj1daSBE0xDiCd4661IBkTnuI1pPzJ*SX85i325ot1JzT2sEf1nnjjXUucMJQF1GLbts4WiTTJcVIKcwZxVgjd369Q00i*D7jj*xWJ6i0n5FjsV7D5BD6eTFuMnNj7H3vY-';
  }, []);
  return null;
};
